import React from 'react';
import classNames from 'classnames';

import { TAutocompleteOption } from '../Autocomplete';

import styles from './AutocompleteOption.module.scss';

export interface IAutocompleteOptionProps {
    setOpen: (val: boolean) => void;
    onSelect: (val: TAutocompleteOption) => void;
    option: TAutocompleteOption;
    selected: boolean;
}

export const AutocompleteOption = ({ option, setOpen, onSelect, selected }: IAutocompleteOptionProps) => {
    return (
        <li
            onClick={(e: React.MouseEvent<HTMLElement>) => {
                e.stopPropagation();
                onSelect(option);
                setOpen(false);
            }}
            className={classNames(styles.option, {
                [styles['option-selected']]: selected,
            })}
        >
            {option.label}
        </li>
    );
};
